import {
    getOutlookInstance,
    HxObject,
    HxObjectID,
    HxActiveSetEvent,
    HxActiveSetEventType,
    HxCollectionChangeType,
} from '@outlook/hxcore_web';
import { getHxIdMappingInfo, getReferencedIds } from './hxIdMappingInfo';
import { addIdMapping, addReferencedId, removeIdMapping } from './hxIdMap';

export function initializeHxIdMap() {
    // Use getOutlookInstance directly since we expect to be running
    // underneatch hx initialization.
    getOutlookInstance().activeSet.registerHandler({
        onActiveSetChanged,
        // onObjectDeactivated,
    });
}

/**
 * Whenever a hx object is loaded, we check based on type to see if it
 * should be added to our id mapping.
 */
function onActiveSetChanged(events: ReadonlyArray<HxActiveSetEvent>) {
    events.forEach(event => {
        switch (event.type) {
            case HxActiveSetEventType.ObjectChanged:
            case HxActiveSetEventType.ObjectLoaded:
                ensureObjectInHxIdMap(event.object);
                break;
            case HxActiveSetEventType.ObjectDeleted:
                onObjectDeleted(event.objectId);
                break;
            case HxActiveSetEventType.CollectionLoaded:
                if ('items' in event.collection) {
                    event.collection.items.forEach(object => ensureObjectInHxIdMap(object));
                }
                break;
            case HxActiveSetEventType.CollectionChanged:
                event.update.changes.forEach(change => {
                    // Make sure the object is in the map even if it is being removed
                    // from the collection so that we can process the removal.
                    ensureObjectInHxIdMap(change.object);
                    if (change.type == HxCollectionChangeType.ItemRemoved) {
                        onObjectDeleted(change.objectId);
                    }
                });
                break;
        }
    });
}

export function ensureObjectInHxIdMap(hxObject?: HxObject) {
    if (hxObject) {
        addIdMapping(getHxIdMappingInfo(hxObject));
        getReferencedIds(hxObject)?.forEach(idMappingInfo =>
            addReferencedId(hxObject.objectId, idMappingInfo)
        );
    }
}

function onObjectDeleted(hxObjectId: HxObjectID) {
    // If a hx object is being deleted, we may as well remove it from the map.
    // But delay so that we are still able to map the id in this notification batch.
    setTimeout(() => removeIdMapping(hxObjectId.toString()), 0);
}

/**
 * There's a challenge here to manage the lifetime of id mappings. It is quite similar
 * to the challenge of managing hx active set lifetime. As long the data from a hx object
 * is still being used somewhere in the client, then we would like that object to be in the
 * hx active set (so hx will notify us when the object changes) and we should keep that object
 * in the id map so that if the client makes some query involving that object we can find the
 * underlying hx object.
 *
 * Long term, once we integrate graphql at the view layer, we expect the hx active set
 * to accurately track the objects being used by the client. At that point we expect to have
 * accurate tracking for a small number of heavily used object types. For those "well-tracked"
 * types, we will deactivate when they leave the active set. For the rest
 *  */

// todo: turn on once hx.js exposes an object deactivation callback
// const wellTrackedTypes: HxObjectType[] = [HxObjectType.HxConversationHeader];

// function onObjectDeactivated(hxObjectId: HxObjectID) {
//     const objectType = hxObjectId.getObjectType();
//     if (wellTrackedTypes.find(type => type === objectType)) {
//         removeIdMapping(hxObjectId.toString());
//     }
// }
